import axios from 'axios';
import { config } from './config.js';

export var api = {
    getPageLoading : function(){
        //return vue_instance.page_loading;
    },
    base : function(){
        return axios.create({
            baseURL: config.API_BASE,
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Autrollization' : localStorage.getItem('token'),
                'Hash-Teatro': localStorage.getItem('hash_teatro')
            }
        });
    },

    call : function(api_route, data = { filters: {} }){
        var str_params = '';
        var url = api_route.url;

        if(!data.filters) data.filters = {};

        if(data.filters)
            str_params = this.format_url_params(data.filters);

        url = url + str_params;

        url = this.format_url_merge_tags(url, data);

        switch(api_route.method){
            case 'GET' :
                return this.get(url, data);

            case 'POST' :
                return this.post(url, data);

            case 'PUT' :
                return this.put(url, data);

            case 'PATCH' :
                return this.patch(url, data);

            case 'DELETE' :
                return this.delete(url, data);

            default :
                console.error('API METHOD ' + api_route.method + ' DOES NOT EXISTS');
                break;
        }
    },
    /* API METHODS */
    get : function(url, data){
        return this.base().get(url);
    },
    getFile : function(url){
        return axios.create({
            baseURL: config.API_BASE,
            withCredentials: false,
            responseType: 'blob',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Autrollization' : localStorage.getItem('token')
            }
        }).get(url);
    },

    post : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().post(url, data);
    },

    put : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().put(url, data);
    },

    patch : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().patch(url, data);
    },

    delete : function(url, data = { filters: {} }){
        if(!data.filters) data.filters = {};

        return this.base().delete(url, data);
    },

    format_url_params : function(params){

        if(!params){
            params = []
        }

        if(localStorage.getItem('token')){
            params['api_key'] = localStorage.getItem('token');
        }

        var str_params = '';
        if(params){
            str_params = '?';
            var parts = [];
            for(var i in params){
                var value = params[i];

                if(typeof(params[i]) == 'object'){
                    var ids = [];
                    for(var j in params[i]){
                        ids.push(params[i][j].id);
                    }

                    value = ids.join(',');
                }

                parts.push(i + "=" + value);
            }

            str_params = '?'+parts.join("&");
        }


        return str_params;
    },

    format_url_merge_tags : function(url, data){
        for(var i in data) {
            url = url.replace('%' + i + '%', data[i]);
        }
        return url;
    }
}
